import _ from 'lodash';

export default function createPatch(source, update, isRoot = true) {
    const result = {};
    if (source.id) result.id = source.id;

    for (const [key, value] of Object.entries(update)) {
        if (typeof value === 'object' && value) {
            if (!_.isEqual(source[key], value)) {
                result[key] = Array.isArray(value) ? [...value] : { ...value };
            }
        } else if (source[key] !== value) {
            result[key] = value;
        }
    }

    return result;
}
